import { __assign } from "tslib";
import React from 'react';
import StatusMonoHtmlView from './StatusHtml';
import StatusMonoReactView from './Status';
var StatusMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(StatusMonoHtmlView, __assign({}, props));
    }
    return React.createElement(StatusMonoReactView, __assign({}, props));
};
StatusMonoView.displayName = 'StatusMonoView';
export default StatusMonoView;
//# sourceMappingURL=index.js.map